import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { FormlyModule } from '@ngx-formly/core'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { debounceTime, Subject } from 'rxjs'

@Component({
  selector: 'app-search-box',
  imports: [SvgIconComponent, FormlyModule, TranslatePipe],
  templateUrl: './search-box.component.html',
})
export class SearchBoxComponent implements OnInit {
  public model: { sword: string } = { sword: '' }
  public form = new FormGroup({})

  @Input({ required: false }) public placeholder?: string
  @Input({ required: false }) public isLoading: boolean = false
  @Input({ required: false }) public defaultValue: string = ''
  @Output() public changeSearch = new EventEmitter<string>()
  private readonly searchSubject = new Subject<string>()

  public constructor() {}

  public ngOnInit(): void {
    if (this.defaultValue) {
      this.model.sword = this.defaultValue
    }

    this.searchSubject
      .pipe(debounceTime(300)) // wait 300ms after the last event
      .subscribe((value) => this.changeSearch.emit(value))
  }

  public onModelChange(): void {
    if (this.model.sword.length === 0 || this.model.sword.length >= 3)
      this.searchSubject.next(this.model.sword)
  }

  public onClear(): void {
    this.model = { sword: '' }
    this.changeSearch.emit(this.model.sword)
  }
}
